import script from "./games-sort-options.vue?vue&type=script&lang=ts&setup=true"
export * from "./games-sort-options.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__